import { React, useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import "react-toastify/ReactToastify.css";
import Layout from "./components/layout/Layout";
import Home from "./Pages/Home";
import Landing from "./Pages/Landing";
import Dashboard from "./Pages/customers/Dashboard";
import Favourites from "./components/favourite/Favourites";
import Menu from "./components/menu/Menu";
import Accountmanagement from "./components/accountmanagement/Accountmanagement";
import Cart from "./components/cart/Cart";
import Bill from "./components/bill/Bill";
import Delivered from "./components/delivered/Delivered";
import Menudetailsitems from "./components/menu/Menudetailsitems";
import Hqdashboard from "./components/hqdashboard/Hqdashboard";
import Billingreport from "./components/hqReport/BillingReport";
import Productreport from "./components/hqProductAnalysis/ProductReport";

import "./App.css";
import "./assets/css/style.css";
import "./assets/css/custom.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthProvider from "./hooks/customers/AuthProvider";
import PrivateRoute from "./router/route";
import { LoaderContext } from "./components/utils/Contexts";
import Loader from "./components/utils/Loader";
import QuotePdf from "./components/bill/quote/pdf";
import InvoicePdf from "./components/bill/invoice/pdf";
import PendingOrders from "./components/district_manager/PendingOrders";
import Unauthorized from "./Pages/unauthorized/Unauthorized";
import ProtectedRoute from "./components/utils/DmMenus";
import GlobalSearch from "./components/search/global";

function App() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isLoader, setLoader] = useState(false);

  return (
    <div className={`${i18n.language.toLowerCase()} App`}>
      <LoaderContext.Provider value={{ isLoader, setLoader }}>
        <Loader />
        <ToastContainer />
        <AuthProvider>
          <nav className="hide">
            <Link to="/">{t("home")}</Link> |{" "}
            <Link to="/landing">{t("landing")}</Link> |{" "}
            <Link to="/favourites">{t("favourites")}</Link> |{" "}
            <Link to="/menu">{t("menu")}</Link> |{" "}
            <Link to="/accountmanagement">{t("accountmanagement")}</Link> |{" "}
            <Link to="/cart">{t("cart")}</Link> |{" "}
            <Link to="/bill">{t("bill")}</Link> |{" "}
            <Link to="/delivered">{t("delivered")}</Link> |{" "}
            <Link to="/menudetails">{t("menudetails")}</Link> |{" "}
            <Link to="/hqReport">{t("hqdashboard")}</Link>
            
          </nav>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route element={<PrivateRoute />}>
              <Route
                path="/landing"
                element={
                  <Layout showHeader={false} showFooter={false}>
                    <Landing />
                  </Layout>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <Layout>
                    <Dashboard />
                  </Layout>
                }
              />
              <Route
                path="/favourites"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <GlobalSearch key={location.pathname}>
                        <Favourites />
                      </GlobalSearch>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/menu"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <GlobalSearch key={location.pathname}>
                        <Menu />
                      </GlobalSearch>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/accountmanagement"
                element={
                  <Layout>
                    <Accountmanagement />
                  </Layout>
                }
              />
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Cart />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bill"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Bill />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/delivered"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Delivered />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hqdashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Hqdashboard />
                    </Layout>
                  </ProtectedRoute>
                }
              />
               {/* <Route
                path="/hqReport"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <HqReport />
                    </Layout>
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/menu-details/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <GlobalSearch>
                        <Menudetailsitems />
                      </GlobalSearch>
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/district-manager/pending-orders"
                element={
                  <Layout>
                    <PendingOrders />
                  </Layout>
                }
              />
              <Route
                path="/unauthorized"
                element={
                  <Layout>
                    <Unauthorized />
                  </Layout>
                }
              />
              <Route
                path="/hqreport"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Billingreport />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hqproductreport"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Productreport />
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
        <Routes>
          <Route path="/quote/pdf/:quote_id" element={<QuotePdf />} />
          <Route path="/invoice/pdf/:invoice_id" element={<InvoicePdf />} />
        </Routes>
      </LoaderContext.Provider>
    </div>
  );
}

// Export the App component as the default export
export default App;
